import { PropsWithChildren, useState, FC } from 'react';
import { DialogTrigger, Dialog } from '@ui/components';

import { VehicleMassImportFileUpload } from './vehicle-mass-import-file-upload/vehicle-mass-import-file-upload';
import { VehicleMassImportSummary } from './vehicle-mass-import-summary/vehicle-mass-import-summary';
import { VehicleMassImportRemove } from './vehicle-mass-import-remove/vehicle-mass-import-remove';
import { useVehicleMassImport } from './use-vehicle-mass-import';

export const VehicleMassImportDialog: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const { resetFile, dialogType, uploadFile, downloadErrorFileCsv, saveImport } =
    useVehicleMassImport(() => {
      setOpen(false);
      resetFile();
    });

  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) {
          resetFile();
        }
        setOpen(value);
      }}
      open={open}
    >
      <DialogTrigger asChild>{children}</DialogTrigger>
      {dialogType === 'UPLOAD' && <VehicleMassImportFileUpload uploadFile={uploadFile} />}
      {dialogType === 'SUMMARY' && (
        <VehicleMassImportSummary
          downloadErrorFileCsv={downloadErrorFileCsv}
          saveImport={saveImport}
        />
      )}
      {dialogType === 'REMOVE' && <VehicleMassImportRemove />}
    </Dialog>
  );
};
